module.exports = __webpack_public_path__ + "static/images/styles/images/reserves/journal/artillery-strike-elite.61aec2a2.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/reserves/journal/artillery-strike-elite.png
// module id = 3732
// module chunks = 11